import React from 'react';
import * as icons from './icons';

const Icon = (props) => <span className={props.className}>
        <svg width="20" height="20" viewBox="0 0 1024 1024" className="icon-inner">
            <path d={icons.getPath(props.name)}></path>
        </svg>
    </span>

export default Icon;